import store from '../store';

export default config => {
    config.headers.authorization = store.getState().app.token;

    return config;
};